<template>
    <div id="Console">
        <el-card shadow = "never">
            <el-row>
                <el-col :span="23" :offset="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        label-width="80px"
                        class="demo-ruleForm"
                    >
                        <el-form-item label="账号" prop="userId">
                            <el-select
                                v-model="value"
                                filterable
                                placeholder="加载中"
                                :clearable="clearable"
                                @change="handleChange2"
                                size="large"
                                style="width : 350px"
                                :disabled="disabled"
                            >
                                <i
                                    class="el-icon-loading"
                                    slot="prefix"
                                    v-if="isLoading"
                                ></i>
                                <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="日期" prop="date">
                            <el-date-picker
                                v-model="ruleForm.date"
                                type="daterange"
                                range-separator="至"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :default-value="defaultVal"
                            >
                            </el-date-picker>
                            <p class="tip"><span>*</span>{{ dateNullTip }}</p>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="submitForm('ruleForm')"
                                >确认</el-button
                            >
                            <el-button @click="cancel">返回</el-button>
                            <el-button @click="downLoad2('订单查询')" type="success"
                                >下载表格</el-button
                            >
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16">
                    <el-button-group>
                        <el-button
                            type="info"
                            icon="el-icon-refresh"
                            @click="refresh"
                            >刷新</el-button
                        >
                    </el-button-group>
                    <span style="margin-left:10px">日期: {{ textDate }}</span>
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input
                        placeholder="订单号或券号"
                        v-model="input5"
                        class="input-with-select"
                        clearable
                    >
                    </el-input>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName" @tab-click="handleClickTab">
                <el-tab-pane label="待付款" name="待付款">
                    <el-table
                        :data="tableData2"
                        border
                        style="width: 100%"
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                        max-height="340"
                        tooltip-effect="dark"
                    >
                        <el-table-column
                            fixed
                            prop="orderDateTime"
                            label="日期"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column prop="orderNo" label="订单号" width="200">
                        </el-table-column>
                        <el-table-column
                            prop="products"
                            label="产品名称"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <p
                                    v-for="item in scope.row.products"
                                    :key="item.orderNo"
                                >
                                    {{ item.productName }}
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalAmount"
                            label="数量"
                            width="120"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="totalPrice"
                            label="总价"
                            width="100"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column prop="orderStatus" label="状态" width="80">
                            <template slot-scope="scope">
                                <p
                                    v-if="scope.row.orderStatus == 0"
                                    class="order-completed"
                                >
                                    已完成
                                </p>
                                <p
                                    v-if="scope.row.orderStatus == 1"
                                    class="order-error"
                                >
                                    支付错误
                                </p>
                                <p v-if="scope.row.orderStatus == 2" class="red">
                                    未支付
                                </p>
                                <p
                                    v-if="scope.row.orderStatus == 3"
                                    class="order-cancle"
                                >
                                    已超时
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="vmsNo" label="券号" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="salesId"
                            label="账号"
                            width="160"
                        ></el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleClick(scope.row)"
                                    type="text"
                                    size="small"
                                    >查看详情</el-button
                                >
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="已完成" name="已完成">
                    <el-table
                        :data="tableData2"
                        border
                        style="width: 100%"
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                        max-height="340"
                        show-summary
                        :summary-method="getSummaries"
                        tooltip-effect="dark"
                    >
                        <el-table-column
                            fixed
                            prop="orderDateTime"
                            label="日期"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column prop="orderNo" label="订单号" width="200">
                        </el-table-column>
                        <el-table-column
                            prop="products"
                            label="产品名称"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <p
                                    v-for="item in scope.row.products"
                                    :key="item.orderNo"
                                >
                                    {{ item.productName }}
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalAmount"
                            label="数量"
                            width="120"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="totalPrice"
                            label="总价"
                            width="100"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column prop="orderStatus" label="状态" width="80">
                            <template slot-scope="scope">
                                <p
                                    v-if="scope.row.orderStatus == 0"
                                    class="order-completed"
                                >
                                    已完成
                                </p>
                                <p
                                    v-if="scope.row.orderStatus == 1"
                                    class="order-error"
                                >
                                    支付错误
                                </p>
                                <p v-if="scope.row.orderStatus == 2" class="red">
                                    未支付
                                </p>
                                <p
                                    v-if="scope.row.orderStatus == 3"
                                    class="order-cancle"
                                >
                                    已超时
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="vmsNo" label="券号" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="salesId"
                            label="账号"
                            width="160"
                        ></el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleClick(scope.row)"
                                    type="text"
                                    size="small"
                                    >查看详情</el-button
                                >
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="已超时" name="已超时">
                    <el-table
                        :data="tableData2"
                        border
                        style="width: 100%"
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                        max-height="340"
                        tooltip-effect="dark"
                    >
                        <el-table-column
                            fixed
                            prop="orderDateTime"
                            label="日期"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column prop="orderNo" label="订单号" width="200">
                        </el-table-column>
                        <el-table-column
                            prop="products"
                            label="产品名称"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <p
                                    v-for="item in scope.row.products"
                                    :key="item.orderNo"
                                >
                                    {{ item.productName }}
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalAmount"
                            label="数量"
                            width="80"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="totalPrice"
                            label="总价"
                            width="100"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column prop="orderStatus" label="状态" width="80">
                            <template slot-scope="scope">
                                <p
                                    v-if="scope.row.orderStatus == 0"
                                    class="order-completed"
                                >
                                    已完成
                                </p>
                                <p
                                    v-if="scope.row.orderStatus == 1"
                                    class="order-error"
                                >
                                    支付错误
                                </p>
                                <p v-if="scope.row.orderStatus == 2" class="red">
                                    未支付
                                </p>
                                <p
                                    v-if="scope.row.orderStatus == 3"
                                    class="order-cancle"
                                >
                                    已超时
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="vmsNo" label="券号" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="salesId"
                            label="账号"
                            width="160"
                        ></el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleClick(scope.row)"
                                    type="text"
                                    size="small"
                                    >查看详情</el-button
                                >
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="全部" name="全部">
                    <el-table
                        :data="tableData2"
                        border
                        style="width: 100%"
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                        max-height="340"
                        show-summary
                        :summary-method="getSummaries"
                        tooltip-effect="dark"
                    >
                        <el-table-column
                            fixed
                            prop="orderDateTime"
                            label="日期"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column prop="orderNo" label="订单号" width="200">
                        </el-table-column>
                        <el-table-column
                            prop="products"
                            label="产品名称"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <p
                                    v-for="item in scope.row.products"
                                    :key="item.orderNo"
                                >
                                    {{ item.productName }}
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalAmount"
                            label="数量"
                            width="80"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="totalPrice"
                            label="总价"
                            width="100"
                            align="right"
                        >
                        </el-table-column>
                        <el-table-column prop="orderStatus" label="状态" width="80">
                            <template slot-scope="scope">
                                <p
                                    v-if="scope.row.orderStatus == 0"
                                    class="order-completed"
                                >
                                    已完成
                                </p>
                                <p
                                    v-if="scope.row.orderStatus == 1"
                                    class="order-error"
                                >
                                    支付错误
                                </p>
                                <p v-if="scope.row.orderStatus == 2" class="red">
                                    未支付
                                </p>
                                <p
                                    v-if="scope.row.orderStatus == 3"
                                    class="order-cancle"
                                >
                                    已超时
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="vmsNo" label="券号" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="salesId"
                            label="账号"
                            width="160"
                        ></el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleClick(scope.row)"
                                    type="text"
                                    size="small"
                                    >查看详情</el-button
                                >
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins: [requestMixin, common],
    data () {
        return {
            ruleForm: {
                userId: '',
                date: ''
            },
            defaultVal: [],
            rules: {
                userId: [
                    { required: true, message: '请先加载账号', trigger: 'blur' },
                ],
            },
            clearable: false,
            disabled: true,
            isLoading: true,
            value: '',
            options2: [],

            input5: '',
            loading: false,
            activeName: '待付款',
            tableData: [
            ],
            textDate: '',
            date: []

        }
    },
    created () {
    },
    mounted () {
        let now = this.formatDate(new Date());
        let date = [now, now];
        this.date = date;
        let userId2 = sessionStorage.getItem("userId");
        this.value = userId2;
        this.ruleForm.userId = userId2;
        this.options2 = [{
            value: userId2,
            label: userId2
        }];
        this.isLoading = false;
        this.defaultNow();
        this.activeName = "待付款";
        // this.getAllOrders(date,'待付款');
    },
    methods: {
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let { userId, date } = that.ruleForm;
                    let userId2 = sessionStorage.getItem("userId");
                    that.tableData = [];
                    // console.log(date)
                    if(date == null){
                        date = ["2020-07-01","2099-10-31"]
                    }
                    that.date = date;
                    //that.textDate = `${date[0]}_${date[1]}`;
                    this.getAllOrders(date, that.activeName);
                } else {
                    return false;
                }
            });
        },
        refresh () {
            this.getAllOrders(this.date, this.activeName);
        },
        handleClickTab (tab, event) {
            let that = this;
            that.activeName = tab.name;
            that.getAllOrders(that.date, tab.name);
        },
        downLoad2 (name) {
            this.isDownTable(this.tableData2, this.downLoad, name);
        },
        //获取当前日期
        formatDate (date) {
            date = new Date(date);
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate()
            const formatNumber = n => {
                n = n.toString()
                // console.log(n)
                return n[1] ? n : '0' + n
            }
            return [year, month, day].map(formatNumber).join('-')
        },
        getAllOrders (date, title) {
            // console.log(date)
            let that = this;
            let userId = sessionStorage.getItem("userId");
            let params;
            that.loading = true;
            if (title == "待付款") {
                params = {
                    act: "orderList",
                    from: date[0],
                    to: date[1],
                    userId,
                    orderStatus: 2
                }
            } else if (title == "已完成") {
                params = {
                    act: "orderList",
                    from: date[0],
                    to: date[1],
                    userId,
                    orderStatus: 0
                }
            } else if (title == "已超时") {
                params = {
                    act: "orderList",
                    from: date[0],
                    to: date[1],
                    userId,
                    orderStatus: 3
                }
            } else if (title == "全部") {
                params = {
                    act: "orderList",
                    from: date[0],
                    to: date[1],
                    userId
                }
            }
            that.delType(params).then((res) => {
                // console.log(res)
                let { data, code } = res.data;
                
                if (code == 200) {
                    that.loading = false;
                    that.allOrder = data;
                    that.tableData = data;
                }
            }).catch(error => {
                that.loading = false;
                // console.log(error)
            })
        },
        // getAllOrders (date,title) {
        //     let that = this;
        //     let userId = sessionStorage.getItem("userId");
        //     let now = that.formatDate(new Date());
        //     that.textDate = now;
        //     let params = {
        //         act: 'orderList',
        //         from: date[0],
        //         to: date[1],
        //         userId
        //     }
        //     that.loading = true;
        //     if (title == "待付款") {
        //         params = {
        //             act: "orderList",
        //             from: date[0],
        //             to: date[1],
        //             userId,
        //             orderStatus: 2
        //         }
        //     } else if (title == "已完成") {
        //         params = {
        //             act: "orderList",
        //             from: date[0],
        //             to: date[1],
        //             userId,
        //             orderStatus: 0
        //         }
        //     } else if (title == "已超时") {
        //         params = {
        //             act: "orderList",
        //             from: date[0],
        //             to: date[1],
        //             userId,
        //             orderStatus: 3
        //         }
        //     }
        //     that.delType(params).then((res) => {
        //         console.log(res)
        //         let { data, code } = res.data;
        //         that.loading = false;
        //         if (code == 200) {
        //             that.allOrder = data;
        //             that.tableData = data;
        //         }
        //     }).catch(error => {
        //         that.loading = false;
        //         console.log(error)
        //     })
        // },
        filterOrder (allOrder, status, filterCon = '') {
            let that = this;
            let order = allOrder.filter(elem => {
                if (filterCon == '') {
                    return elem.orderStatus == status;
                } else {
                    return elem.orderStatus == status && (elem.orderNo.indexOf(filterCon) !== -1 || elem.vmsNo.indexOf(filterCon) !== -1)
                }
            })
            // console.log(status + ':' + order)
            return order
        },
        //跳转详情
        handleClick (e) {
            let { orderNo, salesId } = e;
            this.$router.push({
                path: '/setting/orderDetails',
                query: {
                    orderNo,
                    userId: salesId
                }
            })
        },
        getSummaries (param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                if (index === 1) {
                    sums[index] = '';
                    return;
                }
                if (index === 5) {
                    sums[index] = '';
                    return;
                }
                if (index === 6) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    // sums[index]
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },
        defaultNow () {
            let defaultVal = this.defaultVal;
            defaultVal[0] = new Date();
            defaultVal[0] = defaultVal[0].getFullYear() + '-' + this.checkTime(defaultVal[0].getMonth() + 1) + '-' + this.checkTime(defaultVal[0].getDate());
            defaultVal[1] = defaultVal[0];
            this.ruleForm.date = defaultVal;
        },
        cancel () {
            this.$router.go(-1)
        },
        handleChange2 (value) {
            this.ruleForm.userId = value;
            this.tableData = [];
        },
    },
    computed: {
        tableData2: function () {
            let value = this.input5;
            return this.tableData.filter((elem, i) => {
                return (elem.orderNo.indexOf(value) !== -1 || elem.vmsNo.indexOf(value) !== -1)
            })
        },

    }
}
</script>

<style scoped>
.demo-table-expand {
    font-size: 0;
}
.demo-table-expand .el-form-item__label {
    width: 90px !important;
    color: #99a9bf;
}
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
.oneLineStyle {
    margin: 0 auto;
}
.img-center {
    text-align: center;
}
.el-table {
    margin-top: 20px;
}
.red {
    color: red;
}
.order-completed {
    color: #00c468;
}
.order-error {
    color: orange;
}
.order-cancle {
    color: slategray;
}
</style>



